import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: true,
  imports: [FormsModule, MatDialogModule, MatButtonModule, MatCheckboxModule],
  selector: 'app-dialog-conferma-informativa',
  templateUrl: './dialog-conferma-informativa.component.html',
  styleUrls: ['./dialog-conferma-informativa.component.scss']
})
export class DialogConfermaInformativaComponent implements OnInit {
  testoInformativa = '';
  showButtonNo = true;
  buttonNoText = 'No';
  buttonOkText = 'Si';
  titolo = 'Conferma azione';
  linkInformativa = '';
  ckInformativa = false;
  constructor(
    public dialogRef: MatDialogRef<DialogConfermaInformativaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.testoInformativa = this.data.testoInformativa;
    this.linkInformativa = this.data.linkInformativa;
    this.showButtonNo = this.data.showButtonNo != null ? this.data.showButtonNo : this.showButtonNo;
    this.buttonNoText = this.data.buttonNoText ? this.data.buttonNoText : this.buttonNoText;
    this.buttonOkText = this.data.buttonOkText ? this.data.buttonOkText : this.buttonOkText;
    this.titolo = this.data.titolo ? this.data.titolo : this.titolo;
  }

  ngOnInit() {}
  chiudiDialog(response) {
    this.dialogRef.close(response);
  }
}
